import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DmsApiService } from '../_services/dms-api.service';
import { ISearchForm } from '../_models/search';
import { SearchService } from '../_services/search.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { DocumentService } from '../_services/document.services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '@environments/environment';
import { FormsModule } from '@angular/forms';
import { DialogSaveSearchComponent } from './dialog-save-search/dialog-save-search.component';
import { MatDialog } from '@angular/material/dialog';
import { AppConfig } from 'src/assets/config/config/app-config';
import { style } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { CategoryService } from '../_services/category.service';
import { first } from 'rxjs/operators';
import { Document } from 'src/app/_models/document';
import { AuthenticationService } from '../_services/authentication.service';
import { User } from '../_models';

class SearchCriterion {
  bindingName: string;
  value: string;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  searchResultsList: MatTableDataSource<any>;
  selection: SelectionModel<any>;
  initialData: Array<JSON> = [];
  width: String = "100";
  appError: String = "";
  hideDocList: boolean = false;
  noSearchForms: boolean = false;
  isExportLink: boolean = false;
  isExportMetaDataCsv: boolean = false;
  exportExpiration: number = 60;
  filterValueNavBar: string = null;
  archive: boolean;
  totalDoc: number;

  pageSize = 50;
  pageIndex = 0;
  currentPageSize = 0;
  currentStartPageIndex = 0;

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.searchResultsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.searchResultsList.paginator = this.paginator;
    }
  }
  events: string[] = [];
  opened: boolean;

  constructor(
    private apiSvc: SearchService,
    private cdref: ChangeDetectorRef,
    private documentService: DocumentService,
    private categoryService: CategoryService,
    private authenticationService: AuthenticationService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private config: AppConfig,
    private httpClient: HttpClient
  ) { }

  searchForms: ISearchForm[];
  searchCriteria: any;
  searchResults: Array<JSON> = [];
  selectedRow: Array<JSON> = [];
  selectedForm: ISearchForm;
  searchResultsCols: String[] = [];
  colKeys: string[] = [];
  dynamicSearchCols: string[] = [];
  retentionSearchCols: string[] = [];
  editSearchToggle: boolean = false;
  selectedHold: number = 0;
  documentId: String;
  rowSelection: boolean = false;
  docCount: number;
  offset: number = 0;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  selectedDoc: any;
  allSearchForms: any
  noSearchResults: boolean = false;
  navBarForms = []
  isCaseInsensitive: boolean = true;
  showArchived: boolean = false;
  filterValue: string;
  savedSearchQueries: any
  selectedSavedSearchQuery: any;
  savedSearchQueryNames: string[]
  selectedName: string
  isSavedSearchQuery: boolean
  isUpdateSavedSearchQuery: boolean = false
  formId: number;
  searchCtrl: string = "";
  dynamicValues: any[] = [];
  openVersionUpload: boolean = false;
  openMetaData: boolean = false;
  hideDocView: Boolean = false;
  isDocLocked: boolean = false;
  isLockUser: boolean = false;
  selectDocument:any;
  activeDocumentDetails: Document = null;
  currentUser: User;
  counties: string;

  allCategories = []
  selectedFormDisplayList = []
  systemAttrDisplayList = []
  visibleFields = ["Document Type", "Key Date", "Subject", "Water Right ID"];

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.archive = this.config.getConfig("archive");
    this.apiSvc.getSearchForms()
      .subscribe(forms => {
        this.searchForms = forms;
        this.allSearchForms = forms
        this.navBarForms = forms
        if (this.allSearchForms == "No search forms to be displayed") {
          this.noSearchForms = true
        }
        else {
          this.noSearchForms = false
        }
      });
    this.categoryService.getAll().pipe(first()).subscribe(
          resp => {
            this.allCategories = resp['results'];
            this.getDisplayListData();
          }
        );
  }

  ngAfterContentChecked() {
    //this.selectedRow = undefined
    this.cdref.detectChanges();
  }

  editSearch(event, formId) {
    this.getForm(event, formId);
    this.editSearchToggle = true;
  }

  getDisplayListData() {
    var ignoreListForMetadata = ["Document ID", "Document Title", "Document Version", "Created By", "Creation Date", "File Type", "Modified By", "Modified Date", "Size", "Source"];
    this.selectedFormDisplayList = [
      { name: "Document ID", value: "documentId", visible: false, type: "original", data_type: "str"},
      { name: "Document Title", value: "documentName", visible: false, type: "original", data_type: "str"},
      { name: "Document Version", value: "VersionNumber", visible: false, type: "original", data_type: "str"},
      { name: "Creation Date", value: "createdDate", visible: false, type: "original", data_type: "str"},
      { name: "Created By", value: "created_by", visible: false, type: "original", data_type: "str"},
      { name: "Modified Date", value: "modifiedDate", visible: false, type: "original", data_type: "str"},
      { name: "Modified By", value: "modified_by", visible: false, type: "original", data_type: "str"},
      { name: "Document Source", value: "Source", visible: false, type: "properties", data_type: "str"}
    ]
    for (let category of this.allCategories) {
      for (let metaData of category.meta_data_definition) {
        if (metaData.active) {
          for (let property of metaData.properties) {
            var obj = {}
            if (property.name && !ignoreListForMetadata.includes(property.name.trim())) {
              obj["name"] = property.name.trim()
              obj["value"] = property.name.trim()
              obj["data_type"] = property.data_type
              obj["type"] = "properties"
              if (this.visibleFields.includes(property.name)) {
                obj["visible"] = true;
              } else {
                obj["visible"] = false;
              }
              this.selectedFormDisplayList.push(obj)
            } else {
              console.log(property.name)
            }
          }
        }
      }
    }
    this.systemAttrDisplayList = [
      { name: "File Type", value: "type", visible: false, type: "system" },
      { name: "Size", value: "size" , visible: false, type: "system"}
    ]
    for (let property of this.systemAttrDisplayList) {
      var obj = {}
      obj["name"] = property.name
      obj["value"] = property.value
      obj["type"] = property.type
      obj["data_type"] = "str"
      obj["visible"] = property.visible
      this.selectedFormDisplayList.push(obj)
    }
    this.selectedFormDisplayList = this.removeDuplicateFromDisplayList(this.selectedFormDisplayList, "name");
    this.selectedFormDisplayList = this.sortDisplayList(this.selectedFormDisplayList, "name");
    var additionalColsStr= localStorage.getItem('additionalColumns');
    if (additionalColsStr) {
      var additionalColsList = JSON.parse(additionalColsStr);
      if (additionalColsList && additionalColsList.length > 0) {
        additionalColsList.forEach(colName => {
          let selectedItem = this.selectedFormDisplayList.filter(selectedForm => selectedForm["name"] === colName);
          if (selectedItem.length > 0) {
            selectedItem[0]["visible"] = true;
          }
        });
      }
    }
  }

  applyShowHideColumns() {
    var additionalCols: String[] = []
    this.searchResultsCols = []
    this.searchResultsCols.push("select");
    var additionalColumnsStorageList = [];
    this.selectedFormDisplayList.forEach(function (key) {
      if (key.visible) {
        additionalCols.push(key.name);
      }
    });

    additionalCols.forEach((colName:string) => {
      if (!this.visibleFields.includes(colName)) {
        additionalColumnsStorageList.push(colName);
      }
    });

    localStorage.setItem('additionalColumns', JSON.stringify(additionalColumnsStorageList));

    for (var i = 0; i < additionalCols.length; i++) {
      this.searchResultsCols.push(additionalCols[i])
    }
    this.searchResultsCols.push("actionButton");
  }

  removeDuplicateFromDisplayList = (array, key) => {
    var check = new Set();
    return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
  }

  sortDisplayList = (array, key) => {
    return array.sort((a, b) => {
      return a[key].localeCompare(b[key]);
    });
  }

  closeTabs(hide: boolean) {
    if (hide) {
      this.openMetaData = false
      this.openVersionUpload = false
    }
  }

  backFromMetaData(hide: boolean) {
    if (hide) {
      this.openMetaData = true;
    }
    else {
      this.openMetaData = false
      this.ngOnInit();
      //this.selectedDoc.VersionNumber = this.activeDocumentDetails.activeVersion + 1
    }
  }

  subscribe(docDetails) {
    this.selectDocument = docDetails
    this.selectedDoc = this.selectDocument.documentId
    this.fetchServiceData()
  }

  openUploadDocument() {
    this.openVersionUpload = true
    this.openMetaData = false
  }

  openUpdateMetaData() {
    this.openMetaData = true
    this.openVersionUpload = false
  }

  lockUnlockDocument(lockStatus) {
    this.isDocLocked = !this.activeDocumentDetails.locked
    if (lockStatus) {
      this.documentService.unlockDocument(this.selectedDoc)
        .subscribe(
          resp => {
            this.fetchServiceData()
            //this.ngOnInit()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
              //this.appError = errObj.message
            }
          });

    } else {
      this.documentService.lockDocument(this.selectedDoc)
        .subscribe(
          resp => {
            this.fetchServiceData()
            //this.ngOnInit()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
              //this.appError = errObj.message
            }
          });
    }
  }


  backFromUpload(hide: boolean) {
    if (hide) {
      this.openVersionUpload = true;
    }
    else {
      this.openVersionUpload = false
      this.selectDocument.VersionNumber = this.activeDocumentDetails.activeVersion + 1
      this.fetchServiceData()
    }
  }

  fetchServiceData() {
    this.hideDocView = true
    this.documentService.getDocumentDetails(this.selectedDoc)
      .subscribe(details => {
        this.hideDocView = false;
        this.activeDocumentDetails = details;
        this.isDocLocked = this.activeDocumentDetails.locked;
        if (details.locked == true && details.locked_by != this.currentUser.username) {
          this.isLockUser = true
        }
      });
  }

  getForm(event, formId) {
    this.noSearchResults = false
    this.formId = formId
    this.searchCriteria = [];
    this.searchResults = [];
    this.counties = "";
    this.selectedForm = this.searchForms.find(x => x.id == formId);
    this.selectedForm.form.forEach(form => {
      form.values = ""
    })

    for (const data of this.selectedForm.form) {
      if (data.UIControl == "Dynamic") {
        console.log("Dynamic- " + JSON.stringify(data));
        var payload = {
          "attribute": data.attribute,
          "categories": this.selectedForm.categories,
          "criterion": data.criterion.split('=')[0]
        };

        this.apiSvc.fetchAttributeValues(payload)
          .subscribe(values => {
            this.dynamicValues[data.attribute] = values;
          });
      }
    }

    this.apiSvc.getSavedSearchForms(formId).subscribe(forms => {
      this.savedSearchQueries = forms;
      this.selectedName = forms.name;
      if (Object.keys(this.savedSearchQueries).length == 0) {
        this.isSavedSearchQuery = false
      }
      else {
        this.isSavedSearchQuery = true
      }
      this.savedSearchQueryNames = Object.keys(forms)
    });
    this.editSearchToggle = false;
    this.documentId = null;
    this.width = "100";
    this.hideDocList = false
  }

  getDocDetails(event, row) {
    this.rowSelection = true;
    this.hideDocList = true;
    this.width = "50";
    this.documentId = row.documentId;
    this.selectedDoc = row
    //console.log(this.documentId);
  }

  getSavedSearchQueries(selectedName) {
    this.selectedSavedSearchQuery = selectedName
    var savedQuery = this.savedSearchQueries[selectedName]
    this.selectedForm.form.forEach(form => {
      var bindingName = form.bindingName
      form.values = savedQuery[bindingName]
    })
  }

  trackByIndex(index, item) {
    return item.id;
  }

  next(sidenav) {
    this.offset = this.offset + 200
    this.executeSearch(event, sidenav)
  }

  previous(sidenav) {
    this.offset = this.offset - 200
    this.executeSearch(event, sidenav)
  }

  saveSearchResult() {
    var saveSearchReq = {}
    var object = {}
    this.searchCriteria.forEach(element => {
      element.forEach(value => {
        var saveSearchReq = {}
        saveSearchReq[value['bindingName']] = value.value
        Object.assign(object, saveSearchReq);
      });
    });
    saveSearchReq['formid'] = this.formId
    saveSearchReq['criteria'] = object
    let dialogref = this.dialog.open(DialogSaveSearchComponent, { width: '500px', data: saveSearchReq })

    dialogref.afterClosed().subscribe(resp => {
      this.getForm(event, this.formId)
    })
  }

  updateSearchResult() {
    var saveSearchReq = {}
    var object = {}
    this.searchCriteria.forEach(element => {
      element.forEach(value => {
        var saveSearchReq = {}
        saveSearchReq[value['bindingName']] = value.value
        Object.assign(object, saveSearchReq);
      });

    });
    saveSearchReq['formid'] = this.formId
    saveSearchReq['criteria'] = object
    saveSearchReq['name'] = this.selectedSavedSearchQuery
    let dialogref = this.dialog.open(DialogSaveSearchComponent, { width: '500px', data: saveSearchReq })
  }

  selectPage(pageOptions) {
    this.pageIndex = pageOptions.pageIndex;
    this.pageSize = pageOptions.pageSize;
    let currentPageSize = this.pageSize;
    this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
    currentPageSize = currentPageSize * (this.pageIndex + 1);
    if (currentPageSize >= this.docCount && currentPageSize < this.totalDoc) {
      this.offset += 200;
      this.asyncExecuteSearch();
    }
    this.currentPageSize = currentPageSize;
  }

  async asyncExecuteSearch() {
    if (this.selectedSavedSearchQuery == null) {
      this.isUpdateSavedSearchQuery = false
    }
    else {
      this.isUpdateSavedSearchQuery = true
    }
    this.appError = null;
    // this.searchResultsCols = ["select", "categoryName", "documentName", "created_by"];

    var searchReq = {
      "searchformId": String(this.selectedForm.id),
      "offset": this.offset,
      "limit": 200,
      "storage_class": "S3",
      "criteria": []
    };
    this.searchCriteria = []
    this.searchCriteria.push(searchReq.criteria)
    //populate search request

    if (this.showArchived) {
      searchReq.storage_class = "Glacier";
    }
    for (const data of this.selectedForm.form) {
      // if (data.UIControl == "Static") {
      //   data.values = data.helpText;
      // }
      if (data.values) {
        var d = JSON.parse(JSON.stringify(data))
        var criterion = new SearchCriterion();
        criterion.bindingName = d.bindingName;
        criterion.value = d.values;
        if (d.operator === "IN") {
          criterion["case_insensitive"] = !this.isCaseInsensitive;
        } else {
          criterion["case_insensitive"] = this.isCaseInsensitive
        }
        if (data.UIControl == "Date") {
          var dateArray = criterion.value.split("-")
          var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
          criterion.value = date
        }
        //criterion["case_insensitive"]= false;
        searchReq.criteria.push(criterion);
      }
    }

    //execute search
    await this.apiSvc.getSearchResults(searchReq)
      .subscribe(resp => {
        console.log("Response", resp)
        if (resp.body == "No search results found") {
          this.noSearchResults = true
          this.docCount = 0
        }
        else {
          this.noSearchResults = false
          this.docCount += resp.body['results'].length
          this.totalDoc = resp.body['count'];
          if (this.docCount >= (this.offset + 200)) {
            this.loadNext = true
          } else {
            this.loadNext = false
          }
          if (this.offset >= 200) {
            this.loadPrevious = true
          } else {
            this.loadPrevious = false
          }
          for (const data of resp.body["results"]) {
            this.searchResults.push(data);
          }
          if (this.docCount > 0) {

            //Get dynamic document columns
            // var categoryKeys = this.searchResults[0]
            // var additionalCols: String[] = []
            // Object.keys(categoryKeys).forEach(function (key) {
            //   if (key.startsWith("display_")) {
            //     additionalCols.push(key)
            //   }
            // })

            // for (var i = 0; i < additionalCols.length; i++) {
            //   this.searchResultsCols.push(additionalCols[i])
            // }
            this.searchResultsList = new MatTableDataSource(this.searchResults);
            this.selection = new SelectionModel<any>(true, []);
            this.searchResultsList.sort = this.sort;
            this.searchResultsList.paginator = this.paginator;
            this.searchResultsList.sortingDataAccessor = (item, property) => {
              var list = this.selectedFormDisplayList.filter((obj) => obj.name == property);
              if (list.length > 0) {
                var selectedItem = list[0];
                let value;
                switch(selectedItem["type"]) {
                  case 'original': return item[selectedItem["value"]];
                  case 'properties': value = item.meta_data.properties[selectedItem["value"]];
                                if (selectedItem["data_type"] === 'date'&& value != undefined) {
                                  return new Date(value);
                                }
                                else {
                                  return value;
                                }
                  case 'system': return item.meta_data.system[selectedItem["value"]];
                  default: return item[property];
                }
              } else {
                return null;
              }
            };
          }
          else {
            this.apiSvc.notify("No search results");
          }
        }
      },
        error => {
          var errObj = JSON.parse(error.error)
          if (error.error['status'] = 400) {
            this.appError = errObj.message
          }
        });
  }

  async executeSearch(event, sidenav) {
    this.resetSearchResults();
    if (this.selectedSavedSearchQuery == null) {
      this.isUpdateSavedSearchQuery = false
    }
    else {
      this.isUpdateSavedSearchQuery = true
    }
    this.appError = null;
    this.searchResultsCols = ["select"];
    if (sidenav.opened) {
      sidenav.toggle();
    }
    this.offset = 0;
    var searchReq = {
      "searchformId": String(this.selectedForm.id),
      "offset": this.offset,
      "limit": 200,
      "storage_class": "S3",
      "criteria": []
    };
    this.searchCriteria = []
    this.searchCriteria.push(searchReq.criteria)
    //populate search request

    if (this.showArchived) {
      searchReq.storage_class = "Glacier";
    }
    const countyForm = this.selectedForm.form.find(
      field => field.bindingName === 'county'
    );

    // Introduced to automatically populate the water right id field based on the selected counties
    const hasCountyInput = !!this.counties && this.counties.trim().length > 0;
    const countyFormat = /^[A-Za-z]+(?:\s+[A-Za-z]+)*(?:\s*,\s*[A-Za-z]+(?:\s+[A-Za-z]+)*)*$/;
    const hasValidCountyFormat = hasCountyInput && countyFormat.test(this.counties.trim());
    if (hasCountyInput) { 
      if (!hasValidCountyFormat) {
        this.apiSvc.notify("Invalid county format. Separate counties with commas only.");
        this.noSearchResults = true
        return;
      } else {
        const counties: string[] = this.counties.split(",").map(county => county.trim());
        const resp =  await this.apiSvc.getWaterRightIdsByCounty({"county": counties}).toPromise();

        if (resp && resp.length === 0) {
          this.apiSvc.notify("No water right IDs found for the inputted counties.");
          this.noSearchResults = true
          return;
        }

        const waterRightIdForm = this.selectedForm.form.find(
          field => field.bindingName === 'water right id'
        );

        if (waterRightIdForm && resp) {
          waterRightIdForm.values = resp.join(",");
        }
      }
    }

    for (const data of this.selectedForm.form) {

      if (data.values) {
        console.log(data)
        var d = JSON.parse(JSON.stringify(data))
        var criterion = new SearchCriterion();
        criterion.bindingName = d.bindingName;
        criterion.value = d.values;
        if (d.operator === "IN") {
          criterion["case_insensitive"] = !this.isCaseInsensitive;
        } else {
          criterion["case_insensitive"] = this.isCaseInsensitive
        }
        if (data.UIControl == "Date") {
          var dateArray = criterion.value.split("-")
          var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
          criterion.value = date
        }
        //criterion["case_insensitive"]= false;
        searchReq.criteria.push(criterion);
      }
    }

    //execute search
    this.docCount = 0
    this.searchResults = []
    this.hideDocList = false
    this.apiSvc.getSearchResults(searchReq)
      .subscribe(resp => {
        console.log("Response", resp)
        if (resp.body == "No search results found") {
          this.noSearchResults = true
          this.docCount = 0
          this.totalDoc = 0
        }
        else {
          this.noSearchResults = false
          this.docCount = resp.body['results'].length
          this.totalDoc = resp.body['count'];
          if (this.docCount >= (this.offset + 200)) {
            this.loadNext = true
          } else {
            this.loadNext = false
          }
          if (this.offset >= 200) {
            this.loadPrevious = true
          } else {
            this.loadPrevious = false
          }
          for (const data of resp.body["results"]) {
            this.searchResults.push(data);
          }
          if (this.docCount > 0) {

            //Get dynamic document columns
            var additionalCols: String[] = []
            this.selectedFormDisplayList.forEach(function (key) {
              if (key.visible) {
                additionalCols.push(key.name);
              }
            })

            for (var i = 0; i < additionalCols.length; i++) {
              this.searchResultsCols.push(additionalCols[i])
            }
            this.searchResultsCols.push("actionButton");
            this.searchResultsList = new MatTableDataSource(this.searchResults);
            this.selection = new SelectionModel<any>(true, []);
            this.searchResultsList.sort = this.sort;
            this.searchResultsList.paginator = this.paginator;
            this.searchResultsList.sortingDataAccessor = (item, property) => {
              var list = this.selectedFormDisplayList.filter((obj) => obj.name == property);
              if (list.length > 0) {
                var selectedItem = list[0];
                let value;
                switch(selectedItem["type"]) {
                  case 'original': return item[selectedItem["value"]];
                  case 'properties': value = item.meta_data.properties[selectedItem["value"]];
                                if (selectedItem["data_type"] === 'date'&& value != undefined) {
                                  return new Date(value);
                                }
                                else {
                                  return value;
                                }
                  case 'system': return item.meta_data.system[selectedItem["value"]];
                  default: return item[property];
                }
              } else {
                return null;
              }
            };
          }
          else {
            this.apiSvc.notify("No search results");
          }
        }
      },
        error => {
          var errObj = JSON.parse(error.error)
          if (error.error['status'] = 400) {
            this.appError = errObj.message
          }
        });
  }

  addIfNotExist(col) {
    if (this.searchResultsCols.indexOf(col) === -1) {
      this.searchResultsCols.push(col);
    }
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.searchResultsList.filter = this.filterValue.trim().toLowerCase();

    if (this.searchResultsList.paginator) {
      this.searchResultsList.paginator.firstPage();
      this.docCount = this.searchResultsList.filteredData.length
    }
  }

  onHideDocList(hide: boolean, sidenav) {
    //console.log("inside emit");
    if (hide) {
      this.hideDocList = true;
    } else {
      // Restore the previously viewed results screen instead of re-running the
      // search (which reset the offset/paginator back to the first page).
      this.hideDocList = false;
      this.selection.clear();
    }
  }


  applyFilterSideNav(event: Event) {
    this.filterValueNavBar = (event.target as HTMLInputElement).value;
    //let count = 0
    //console.log(this.filterValueNavBar)
    if (this.filterValueNavBar.length > 0) {
      this.navBarForms = []
      this.search()
    }
    else {
      this.navBarForms = this.allSearchForms
    }
  }

  search() {
    this.allSearchForms.filter(form => {
      if ((form.name.trim().toLowerCase().indexOf(this.filterValueNavBar.trim().toLowerCase()) > -1)) {
        this.navBarForms.push(form)
      }
    })
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.searchResultsList.data.length;
    return numSelected === numRows;
  }

  masterToggle(ref) {
    if (this.isSomeSelected()) {

      this.selection.clear();
      ref.checked = false;

    } else {
      this.isAllSelected() ?
        this.selection.clear() :
        this.selecteAll();
    }
  }

  isSomeSelected() {
    return this.selection.selected.length > 0;
  }


  selecteAll() {
    if (this.filterValue) {
      this.searchResultsList.filter = this.filterValue.trim().toLowerCase();
      //console.log(this.allPurgeList.filteredData)
      this.searchResultsList.filteredData.forEach(row => {
        this.selection.select(row.documentId)
      });
    }
    else {
      this.searchResultsList.data.forEach(row => this.selection.select(row.documentId));
    }
  }

  exportDocumentLink() {

    let selectedList = this.selection.selected.join().split(",");
    let totalList = [];
    var request;
    if (selectedList.length > 100) {
      request = {
        "document_ids": totalList,
        "expiration_time": this.exportExpiration,
        "searchformId": String(this.selectedForm.id),
        "offset": 0,
        "limit": (this.totalDoc),
        "storage_class": "S3",
        "criteria": [],
        "async": true,
      };
      this.searchCriteria = []
      this.searchCriteria.push(request.criteria)
      //populate search request

      if (this.showArchived) {
        request.storage_class = "Glacier";
      }
      for (const data of this.selectedForm.form) {
        if (data.UIControl == "Static") {
          data.values = data.helpText;
        }
        if (data.values) {
          var d = JSON.parse(JSON.stringify(data))
          var criterion = new SearchCriterion();
          criterion.bindingName = d.bindingName;
          criterion.value = d.values;
          if (d.operator === "IN") {
            criterion["case_insensitive"] = !this.isCaseInsensitive;
          } else {
            criterion["case_insensitive"] = this.isCaseInsensitive
          }
          if (data.UIControl == "Date") {
            var dateArray = criterion.value.split("-")
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
            criterion.value = date
          }
          // criterion["case_insensitive"]= false;
          request.criteria.push(criterion);
        }
      }
    } else {
      totalList = selectedList;
      request = {
        "document_ids": totalList,
        "expiration_time": this.exportExpiration,
        "async": true
      }
    }
    this.selection.clear();
    this.documentService.exportDocumentsLink(request).subscribe(
      response => {
        this.isExportLink=false;
        console.log("Response " + response);
      });

  }

  exportDocuments() {

    let selectedList = this.selection.selected.join().split(",");
    let totalList = [];
    var request;
    if (selectedList.length > 100) {
      request = {
        "docid": totalList,
        "searchformId": String(this.selectedForm.id),
        "offset": 0,
        "limit": (this.offset + 200),
        "storage_class": "S3",
        "criteria": [],
        "async": true,
      };
      this.searchCriteria = []
      this.searchCriteria.push(request.criteria)
      //populate search request

      if (this.showArchived) {
        request.storage_class = "Glacier";
      }
      for (const data of this.selectedForm.form) {
        if (data.UIControl == "Static") {
          data.values = data.helpText;
        }
        if (data.values) {
          var d = JSON.parse(JSON.stringify(data))
          var criterion = new SearchCriterion();
          criterion.bindingName = d.bindingName;
          criterion.value = d.values;
          if (d.operator === "IN") {
            criterion["case_insensitive"] = !this.isCaseInsensitive;
          } else {
            criterion["case_insensitive"] = this.isCaseInsensitive
          }
          if (data.UIControl == "Date") {
            var dateArray = criterion.value.split("-")
            var date = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[0]
            criterion.value = date
          }
          //criterion["case_insensitive"]= false;
          request.criteria.push(criterion);
        }
      }
    } else {
      totalList = selectedList;
      request = {
        "docid": totalList,
        "async": true
      }
    }
    // let subList = this.selection.selected.join().split(",");
    // if (this.currentStartPageIndex == 0) {
    //   this.currentStartPageIndex = 1
    // }
    // if (this.currentPageSize == 0) {
    //   this.currentPageSize = 50
    // }
    // if (totalList.length >= this.currentPageSize) {
    //   subList = totalList.slice(this.currentStartPageIndex - 1, this.currentPageSize);
    // }


    this.selection.clear();
    this.documentService.exportDocuments(request).subscribe(
      response => {
        console.log("Response " + response);
      });
  }

  retrieveGlacierDocuments() {

    var request = {
      "docid": this.selection.selected.join().split(",")
    }
    this.selection.clear();
    this.documentService.retrieveGlacierDocuments(request).subscribe(
      response => {
        this.snackBar.open("Restoration request for the selected documents is placed successfully. The restore status can be tracked from 'Glacier' tab", "Close", {
          duration: 20000
        });
        console.log("Response " + response);
      });
    console.log(request);
  }

  resetSearchResults() {
    this.searchResults = []
    this.docCount = 0
    this.totalDoc = 0
  }


}
